<template>
  <div id="index">
    <ion-app>
      <ion-split-pane content-id="main">
        <Menu />
        <div class="ion-page" id="main">
          <router-view main :animated="false" id="menu-content"/>
        </div>
      </ion-split-pane>
    </ion-app>
  </div>
</template>

<script lang="ts">
import { IonApp, IonSplitPane } from "@ionic/vue";
import { AuthenticationService } from "../service/account/authenticator.service";
import { LocalStorage } from "../data/localstorage";

import Menu from "../components/include/Menu.vue";
import Header from "../components/include/Header.vue";
import { defineComponent } from 'vue';

export default defineComponent ({
  components: {
    IonApp,
    IonSplitPane,
    Menu
  },
  async mounted() {
    let user = new LocalStorage().user;
    if (user) {
      // alert('from menu index')
      // alert(this.$router.currentRoute.value.name)
      if (this.$router.currentRoute.value.name == "appLaunch") {
        let userPermissions = await new AuthenticationService().permissionsOfUser(
          user
        );
        let isCustomer = userPermissions.find(
          (userPermission: any) => userPermission.id == "10|C"
        );
        let isAdmin = userPermissions.find(
          (userPermission: any) => userPermission.id == "10|T"
        );
        if (isCustomer) {
          this.$router.push("/customer/reservation");
        } else if (isAdmin) {
          this.$router.push("/admin/reservations");
        } else {
          this.$router.push("/common/helpdesk");
        }
      }
    } else {
      window.localStorage.clear();
      this.$router.push("/login");
    }
  }
})
</script>

<style scoped>
.split-pane-visible > ion-menu {
  max-width: 200px !important;
}
</style>